import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { allSharedComponents } from "../../../../../shared";
import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { competitionActions } from "../../../../../redux/actions";
import cancelIcon from "../../../../../assets/images/icon/crossIcon.svg";
import Tooltip from "@mui/material/Tooltip";

import {
  translationConstants,
  Directions,
  refreshDispatch,
  TableColumnStyle,
  genderEnum,
  levelEnumReversed,
  genderEnumReversed,
} from "../../../../../constants";
import {
  changeTableSortIcons,
  getSortDirectionProperty,
  removeSpace,
  copyToClipboard,
} from "../../../../../system";
import { useNavigate } from "react-router-dom";
import AddParticipants from "../Components/AddParticipants";
import RefundFrom from "../Components/RefundForm";
import { debounce } from "@mui/material";
const { DataTable, DeleteModal, CustomModal } = allSharedComponents;

const initialGridState = {
  length: 10,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: "",
  search: null,
};

const ParticipantsTab = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const particaipantsPage = useSelector(
    (state) => state.CompetitionReducer.competitionParticipantsDetail.page
  );
  const participantsPageData = useSelector(
    (state) =>
      state.CompetitionReducer.competitionParticipantsDetail.pageData
        ?.competitionParticipants
  );

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const sortingInProgressRef = useRef(false);
  const [rowData, setRowData] = useState("");
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(gridState.pageNumber);
  const [isShow, setIsShow] = useState(false);
  const [isRefundShow, setIsRefundShow] = useState(false);
  const [refundAmount, setRefundAmount] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [inputSearch, setInputSearch] = useState();
  const searchInputRef = useRef(null);

  const noFeeCancellation = (data) => {
    dispatch(
      competitionActions.refundPublicCompetition({
        competitionId: data?.competitionId,
        systemUserId: data?.systemUserId,
        amount: data?.fee.toFixed(2),
      })
    );
  };

  const getcolumns = () => {
    const columns = [
      {
        id: "id",
        accessor: "id",
        name: t(translationConstants.RECORD_ID),
        cell: (row) => (
          <Tooltip
            title={<div>{t(translationConstants.COPY_TO_CLIPBOARD)}</div>}
            placement="top"
            arrow
          >
            <div
              className="truncate-text cursor-pointer"
              onClick={() => copyToClipboard(row.id)}
            >
              {row.id}
            </div>
          </Tooltip>
        ),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
        maxWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "name",
        name: t(translationConstants.name),
        selector: (row) =>
          direction === Directions.rtl
            ? removeSpace(row?.arabicName)
              ? row?.arabicName
              : row?.name
            : row?.name,
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_160,
      },
      {
        id: "email",
        name: t(translationConstants.Email),
        selector: (row) => row?.email,
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_160,
      },
      {
        id: "gender",
        name: t(translationConstants.gender),
        selector: (row) =>
          t(translationConstants[genderEnumReversed[row?.gender]]),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "levelId",
        name: t(translationConstants.LEVEL),
        selector: (row) =>
          t(translationConstants[levelEnumReversed[row.levelId]]),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "isMembershipHolder",
        name: t(translationConstants.IS_MEMBER),
        selector: (row) =>
          row?.isMembershipHolder
            ? t(translationConstants.YES)
            : t(translationConstants.NO),
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      props.isPublicRegistrationAllowed && {
        id: "fee",
        name: t(translationConstants.FEES),
        selector: (row) => row.fee,
        reorder: true,
        sortable: true,
        sortDirection: null,
        minWidth: TableColumnStyle.COLUMN_WIDTH_120,
      },
      {
        id: "actions",
        name: props.isPublicRegistrationAllowed
          ? t(translationConstants.refund)
          : t(translationConstants.Actions),
        center: true,
        cell: (row) => (
          <>
            {row.isActive === false ? (
              props.isPublicRegistrationAllowed ? (
                <span>{row.refundAmount}</span>
              ) : (
                <span>{t(translationConstants.CANCELLED)}</span>
              )
            ) : props.isPublicRegistrationAllowed ? (
              <svg
                width="19"
                height="11"
                viewBox="0 0 19 11"
                onClick={() => {
                  if (row?.fee) {
                    setSelectedUser(row);
                    handleRefund(row.fee, props.refundPercentage, true);
                  } else {
                    noFeeCancellation(row);
                  }
                }}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.1947 2.40019V1.32573C16.1947 0.869248 15.804 0.499219 15.3476 0.499219H1.21423C0.757749 0.499219 0.408382 0.869248 0.408382 1.32573V9.67349C0.408382 10.13 0.757749 10.5 1.21423 10.5H15.3476C15.804 10.5 16.1947 10.13 16.1947 9.67349V4.71442"
                  stroke="black"
                  stroke-width="0.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.1947 7.80374C16.1947 7.96929 16.0605 8.10352 15.895 8.10352H0.708158C0.542608 8.10352 0.408382 7.96929 0.408382 7.80374V5.84111C0.408382 5.67556 0.542608 5.54133 0.708158 5.54133H15.895C16.0605 5.54133 16.1947 5.67556 16.1947 5.84111V7.80374Z"
                  stroke="black"
                  stroke-width="0.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.56536 2.31836H3.71429"
                  stroke="black"
                  stroke-width="0.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.4927 4.45117L12.5772 3.53573L13.4927 2.62029"
                  stroke="black"
                  stroke-width="0.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.6702 3.50601C12.6702 3.50601 17.3477 3.51155 17.3661 3.5123C18.0696 3.5404 18.5916 4.10639 18.5916 4.8181V4.9834C18.5916 5.71371 18.0615 6.28516 17.3312 6.28516H17.1866"
                  stroke="black"
                  stroke-width="0.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                onClick={() => cancelParticipants(row)}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.5 17.252C4.94365 17.252 1.25 13.5583 1.25 9.00195C1.25 4.4456 4.94365 0.751953 9.5 0.751953C14.0563 0.751953 17.75 4.4456 17.75 9.00195C17.75 13.5583 14.0563 17.252 9.5 17.252ZM9.50004 15.7513C13.228 15.7513 16.25 12.7292 16.25 9.0013C16.25 5.27337 13.228 2.2513 9.50004 2.2513C5.77212 2.2513 2.75004 5.27337 2.75004 9.0013C2.75004 12.7292 5.77212 15.7513 9.50004 15.7513ZM7.03078 12.5325L9.50045 10.0628L11.9701 12.5325L13.0308 11.4718L10.5611 9.00212L13.0308 6.53245L11.9701 5.47179L9.50045 7.94146L7.03078 5.47179L5.97012 6.53245L8.43979 9.00212L5.97012 11.4718L7.03078 12.5325Z"
                  fill="#FF0000"
                />
              </svg>
            )}
          </>
        ),
      },
    ];

    // Filter out undefined columns
    return columns.filter((column) => column);
  };
  const [columns, setColumns] = useState(getcolumns());

  const handleRefund = (fee, percentage, isModalShow) => {
    const calculatedAmount = ((fee * percentage) / 100).toFixed(2);
    setRefundAmount(calculatedAmount);
    if (isModalShow) {
      setIsRefundShow(!isRefundShow);
    }
  };

  const cancelParticipants = (data) => {
    dispatch(
      competitionActions.cancelRegistrationPrivate(
        data.systemUserId,
        data.competitionId,
        null,
        refreshDispatch.PARTICIPANT_ADMIN
      )
    );
  };

  const onSort = (sortedColumn) => {
    sortingInProgressRef.current = true;
    setColumns(changeTableSortIcons(columns, sortedColumn));
    const columnDirection = getSortDirectionProperty(sortedColumn);
    setDefaultPage(gridState.pageNumber);
    const orderBy =
      columnDirection !== null
        ? `${sortedColumn.id} ${columnDirection}`
        : "id desc";
    setGridState((prevState) => ({
      ...prevState,
      orderBy: orderBy,
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  useEffect(() => {
    if (participantsPageData !== null) {
      setRowData(participantsPageData);
    }
    // eslint-disable-next-line
  }, [participantsPageData]);

  useEffect(() => {
    setColumns(getcolumns());
    // eslint-disable-next-line
  }, [i18n.dir()]);

  useEffect(() => {
    dispatch(
      competitionActions.getCompetitionParticipantsDetailById(
        props.id,
        gridState
      )
    );
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  const downloadList = () => {
    dispatch(competitionActions.download(props.id, gridState));
  };

  useEffect(() => {
    setGridState((prevState) => ({
      ...prevState,
      search: inputSearch,
    }));
    // eslint-disable-next-line
  }, [inputSearch]);

  const handleSearch = debounce((value) => {
    setInputSearch(value);
  }, process.env.REACT_APP_SEARCH_DEBOUNCE_INTERVAL);

  const handleResetSearch = () => {
    setInputSearch("");
    setGridState((prevState) => ({
      ...prevState,
      search: "",
    }));
    searchInputRef.current.value = "";
  };

  return (
    <>
      <div className="tableContainer">
        <Container className="m-0 p-0 mw-100">
          <Row className="mt-2 mb-4">
            <Col
              md="3"
              xs="12"
              className="d-flex justify-content-sm-start justify-content-center"
            >
              <div className="searchInputDiv gap-2 d-flex justify-content-between align-items-center w-100">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_610_3748)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.4015 13.3185L16.7053 17.6223C16.8565 17.7737 16.9415 17.979 16.9414 18.193C16.9413 18.407 16.8562 18.6122 16.7049 18.7635C16.5535 18.9147 16.3482 18.9997 16.1342 18.9996C15.9202 18.9995 15.715 18.9144 15.5637 18.7631L11.2599 14.4593C9.97335 15.4558 8.35548 15.9247 6.73543 15.7707C5.11539 15.6167 3.61486 14.8513 2.53911 13.6302C1.46336 12.4091 0.893196 10.8241 0.944603 9.19754C0.99601 7.571 1.66513 6.02514 2.81584 4.87443C3.96655 3.72372 5.51241 3.0546 7.13895 3.0032C8.76549 2.95179 10.3505 3.52196 11.5716 4.59771C12.7927 5.67346 13.5581 7.17398 13.7121 8.79402C13.8661 10.4141 13.3972 12.0319 12.4007 13.3185H12.4015ZM7.3417 14.1993C8.61468 14.1993 9.83553 13.6936 10.7357 12.7934C11.6358 11.8933 12.1415 10.6725 12.1415 9.3995C12.1415 8.12652 11.6358 6.90567 10.7357 6.00554C9.83553 5.10541 8.61468 4.59972 7.3417 4.59972C6.06872 4.59972 4.84788 5.10541 3.94775 6.00554C3.04762 6.90567 2.54193 8.12652 2.54193 9.3995C2.54193 10.6725 3.04762 11.8933 3.94775 12.7934C4.84788 13.6936 6.06872 14.1993 7.3417 14.1993Z"
                        fill="#575756"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_610_3748">
                        <rect
                          width="15.9645"
                          height="15.9998"
                          fill="white"
                          transform="translate(0.941406)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <input
                  className="searchInput w-100"
                  type="text"
                  placeholder={t(translationConstants.Search)}
                  onChange={(e) => handleSearch(e.target.value)}
                  ref={searchInputRef}
                />
                {inputSearch && (
                  <div
                    onClick={handleResetSearch}
                    className="cross cursor-pointer"
                  >
                    <img width={16} src={cancelIcon} alt="cancel icon" />
                  </div>
                )}
              </div>
            </Col>
            <Col className="d-flex justify-content-center justify-content-sm-end align-items-center">
              {!props.isPublicRegistrationAllowed ? (
                <Button
                  className="Registeration-button participants-button"
                  type="submit"
                  onClick={() => {
                    setIsShow(!isShow);
                  }}
                >
                  <svg
                    width="13"
                    height="14"
                    viewBox="0 0 13 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.6239 7.87686L0.305033 7.87686L0.305033 6.12465L5.6239 6.12465L5.6239 0.805788H7.3761L7.3761 6.12465L12.695 6.12465L12.695 7.87686L7.3761 7.87686L7.3761 13.1957H5.6239L5.6239 7.87686Z"
                      fill="white"
                    />
                  </svg>
                  &nbsp;
                  {t(translationConstants.ADD_PARTICIPANTS)}
                </Button>
              ) : (
                ""
              )}
              <span
                className="d-flex align-items-center"
                onClick={() => downloadList()}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5777 6.74343L9.83366 9.4875V0.666016H8.16699V9.4875L5.42291 6.74343L4.2444 7.92194L9.00033 12.6779L13.7562 7.92194L12.5777 6.74343Z"
                    fill="black"
                  />
                  <path
                    d="M17.3337 15.666V12.3327H15.667V15.666H2.33366V12.3327H0.666992V15.666C0.666992 16.5865 1.41318 17.3327 2.33366 17.3327H15.667C16.5875 17.3327 17.3337 16.5865 17.3337 15.666Z"
                    fill="black"
                  />
                </svg>
                &nbsp;
                <label className="text-dark me-2">
                  {t(translationConstants.downloadList)}
                </label>
              </span>
            </Col>
          </Row>
        </Container>

        <DataTable
          columns={columns}
          items={rowData}
          onSort={onSort}
          gridState={gridState}
          paginationTotalRows={particaipantsPage?.totalElements}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          paginationDefaultPage={defaultPage}
          paginationResetDefaultPage={true}
        />

        <CustomModal
          scrollable={true}
          size="lg"
          setShow={setIsShow}
          show={isShow}
          customClass="view-user-modal"
        >
          <AddParticipants
            competitionId={props.id}
            setShow={setIsShow}
            show={isShow}
            gridState={gridState}
          />
        </CustomModal>
        <CustomModal
          scrollable={true}
          size="sm"
          setShow={setIsRefundShow}
          show={isRefundShow}
          // customClass="view-user-modal"
        >
          <RefundFrom
            // competitionId={props.id}
            refundPercentage={props.refundPercentage}
            refundAmount={refundAmount}
            selectedUser={selectedUser}
            setShow={setIsRefundShow}
            show={isRefundShow}
            handleRefund={handleRefund}
          />
        </CustomModal>
      </div>
    </>
  );
};

export default ParticipantsTab;
